/**
 * iOS PWA invite handoff.
 *
 * On iOS, links always open in Safari and the installed PWA cannot be
 * deep-linked, nor does it share storage with Safari. The workable bridge is
 * the clipboard: the Safari landing page copies a marked handoff string
 * (`dwinvite:<token>`), the user opens the installed app, and the app reads
 * the clipboard on an explicit user tap (iOS prompts for permission) and
 * routes to /guest-login?token=... with the original one-time token intact.
 */
export const INVITE_HANDOFF_PREFIX = "dwinvite:";
export function isIosDevice() {
    const ua = navigator.userAgent || "";
    const iThing = /iPhone|iPad|iPod/i.test(ua);
    // iPadOS 13+ masquerades as macOS but has touch support.
    const iPadOs = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
    return iThing || iPadOs;
}
export function isStandaloneDisplay() {
    return (window.matchMedia?.("(display-mode: standalone)")?.matches === true ||
        navigator.standalone === true);
}
/** Copy the invite token to the clipboard as a marked handoff string. */
export async function writeInviteHandoff(token) {
    await navigator.clipboard.writeText(`${INVITE_HANDOFF_PREFIX}${token}`);
}
/**
 * Read a pending invite token from the clipboard, if present.
 * Returns null when the clipboard has unrelated content or reading fails.
 * Must be called from a user gesture (iOS shows a paste permission prompt).
 */
export async function readInviteHandoff() {
    try {
        const text = (await navigator.clipboard.readText())?.trim();
        if (!text || !text.startsWith(INVITE_HANDOFF_PREFIX))
            return null;
        const token = text.slice(INVITE_HANDOFF_PREFIX.length).trim();
        return token || null;
    }
    catch {
        return null;
    }
}
